import { Table, Button, Row, Col, Form, Pagination } from 'react-bootstrap';
import { FaEdit, FaPlus, FaTrash } from 'react-icons/fa';
import { Link, useParams } from 'react-router-dom';
import Message from './../components/Message';
import Loader from './../components/Loader';

import {
  useGetHousesQuery,
  useDeleteHouseMutation,
  useCreateHouseMutation,
} from './../slices/housesApiSlice';
import { toast } from 'react-toastify';
import { useState } from 'react';

const StaffHouseList = () => {
  
  const [pageNumber, setPageNumber] = useState(1);
  const { data, isLoading, error, refetch } = useGetHousesQuery({ pageNumber });
  const [deleteHouse, { isLoading: loadingDelete }] = useDeleteHouseMutation();
  const [createHouse, { isLoading: loadingCreate }] = useCreateHouseMutation();

  const [filter, setFilter] = useState('');
  const [sortField, setSortField] = useState('');
  const [sortOrder, setSortOrder] = useState('asc'); // 'asc' for ascending, 'desc' for descending

  const deleteHandler = async (id) => {
    if (window.confirm('Are you sure')) {
      try {
        await deleteHouse(id);
        refetch();
      } catch (err) {
        toast.error(err?.data?.message || err.error);
      }
    }
  };

  const createHouseHandler = async () => {
    if (window.confirm('Are you sure you want to create a new house?')) {
      try {
        await createHouse();
        refetch();
      } catch (err) {
        toast.error(err?.data?.message || err.error);
      }
    }
  };

  const handleSort = (field) => {
    const order = sortField === field && sortOrder === 'asc' ? 'desc' : 'asc';
    setSortField(field);
    setSortOrder(order);
  };

  const filterAndSortHouses = () => {
    let filteredHouses = data.houses;

    // Filter houses by name, agent, type, or address
    if (filter) {
      filteredHouses = filteredHouses.filter(
        (house) =>
          house.name.toLowerCase().includes(filter.toLowerCase()) ||
          house.agent.toLowerCase().includes(filter.toLowerCase()) ||
          house.type.toLowerCase().includes(filter.toLowerCase()) ||
          house.address.toLowerCase().includes(filter.toLowerCase())
      );
    }

    // Sort houses
    if (sortField) {
      filteredHouses.sort((a, b) => {
        if (sortField === 'regularPrice' || sortField === 'discountedPrice') {
          return sortOrder === 'asc'
            ? a[sortField] - b[sortField]
            : b[sortField] - a[sortField];
        } else {
          return sortOrder === 'asc'
            ? a[sortField].localeCompare(b[sortField])
            : b[sortField].localeCompare(a[sortField]);
        }
      });
    }

    return filteredHouses;
  };
    // Handle pagination changes
  const paginationHandler = (page) => {
    setPageNumber(page);
  };


  return (
    <>
      <Row className="align-items-center">
        <Col>
          <h1>Houses</h1>
        </Col>
        <Col className="text-end">
          <Button className="my-3" onClick={createHouseHandler}>
            <FaPlus /> Create House
          </Button>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={4}>
          <Form.Control
            type="text"
            placeholder="Filter by name, agent, type, or address"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          />
        </Col>
      </Row>

      {loadingCreate && <Loader />}
      {loadingDelete && <Loader />}
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">{error.data.message}</Message>
      ) : (
        <>
          <Table striped bordered hover responsive className="table-sm">
            <thead>
              <tr>
                <th
                  onClick={() => handleSort('name')}
                  style={{ cursor: 'pointer' }}
                >
                  NAME {sortField === 'name' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
                </th>
                <th
                  onClick={() => handleSort('type')}
                  style={{ cursor: 'pointer' }}
                >
                  TYPE {sortField === 'type' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
                </th>
                <th
                  onClick={() => handleSort('agent')}
                  style={{ cursor: 'pointer' }}
                >
                  AGENT {sortField === 'agent' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
                </th>
                <th
                  onClick={() => handleSort('address')}
                  style={{ cursor: 'pointer' }}
                >
                  ADDRESS {sortField === 'address' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
                </th>
                
                <th
                  onClick={() => handleSort('regularPrice')}
                  style={{ cursor: 'pointer' }}
                >
                  PRICE {sortField === 'regularPrice' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
                </th>
                <th
                  onClick={() => handleSort('size')}
                  style={{ cursor: 'pointer' }}
                >
                  More Details {sortField === 'size' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
                </th>
                <th>ACTIONS</th>
              </tr>
            </thead>
            <tbody>
              {filterAndSortHouses().map((house) => (
                <tr key={house._id}>
                  <td>{house.name}</td>
                  <td>{house.type}</td>
                  <td>{house.agent}</td>
                  <td>{house.address}</td>
                  
                  <td>${house.regularPrice.toFixed(2)}</td>
                  <td>{house.size}</td>
                  <td>
                    <Button
                      as={Link}
                      to={`/house/${house._id}/edit`}
                      variant="light"
                      className="btn-sm mx-2"
                    >
                      <FaEdit />
                    </Button>
                    <Button
                      style={{display: "none"}}
                      variant="danger"
                      className="btn-sm"
                      onClick={() => deleteHandler(house._id)}
                    >
                      <FaTrash style={{ color: 'white' }} />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
           <Pagination>
                       {[...Array(data.pages).keys()].map((x) => (
                         <Pagination.Item
                           key={x + 1}
                           active={x + 1 === pageNumber}
                           onClick={() => paginationHandler(x + 1)}
                         >
                           {x + 1}
                         </Pagination.Item>
                       ))}
            </Pagination>

          
        </>
      )}
    </>
  );
};

export default StaffHouseList;